// Identity + role context. Fetches /api/me once; exposes role helpers so the
// shell can hide controls a VIEWER can't use (the server still enforces).
import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api.js";

const MeCtx = createContext({ me: null, loading: true, outage: false, retry: () => {} });

export function MeProvider({ children }) {
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(true);
  // F2 (resource-state contract): ONLY 401/403 mean "logged out". A 5xx or a network failure is an
  // OUTAGE — showing Login for those told the user their session was gone during any server blip.
  const [outage, setOutage] = useState(false);
  const [retryN, setRetryN] = useState(0);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    api("me")
      .then((m) => { if (alive) { setMe(m); setOutage(false); } })
      .catch((e) => { if (alive) { setMe(null); setOutage(!(e?.status === 401 || e?.status === 403)); } })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [retryN]);
  return <MeCtx.Provider value={{ me, loading, outage, retry: () => setRetryN((n) => n + 1) }}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);

export function useRole() {
  const { me } = useMe();
  const role = me?.role || null;
  return {
    role,
    isViewer: !!role,
    isTrader: role === "TRADER" || role === "ADMIN",
    isAdmin: role === "ADMIN",
    isSuperuser: !!me?.is_superuser,   // gates the /admin back office (operator-only)
  };
}
